import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=4f832b4a&scoped=true"
import script from "./SectionTitle.vue?vue&type=script&lang=js"
export * from "./SectionTitle.vue?vue&type=script&lang=js"
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=4f832b4a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f832b4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f832b4a')) {
      api.createRecord('4f832b4a', component.options)
    } else {
      api.reload('4f832b4a', component.options)
    }
    module.hot.accept("./SectionTitle.vue?vue&type=template&id=4f832b4a&scoped=true", function () {
      api.rerender('4f832b4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/SectionTitle.vue"
export default component.exports